import React from "react";
import styles from "./UserCard.module.scss";
import { Card } from "@mui/material";
import { useHistory } from "react-router-dom";
import { CompaniesAPI, UsersAPI } from "api_inbusiness";

import EmailOutlinedIcon from "@mui/icons-material/EmailOutlined";
import PhoneOutlinedIcon from "@mui/icons-material/PhoneOutlined";
import BusinessIcon from "@mui/icons-material/Business";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";

import DefaultUserPicture from "resources/img/user/DefaultUserPicture.png";

const UserCard = ({ user }) => {
  const [userPhoto, setUserPhoto] = React.useState(null);
  const navigate = useHistory();

  React.useEffect(() => {
    (async () => {
      const imgId = user.avatarId;
      if (imgId) {
        const { data: imgUrl } = await UsersAPI.getNewUserPicture(imgId);
        setUserPhoto(imgUrl);
      }
    })();
  }, [user]);

  const getMemberStatus = () => {
    // Pentru MEMBER/EX_MEMBER verifică status activ
    if (user.type === 'MEMBER') {
      return user.active ? 'Membru Activ' : 'Membru';
    }
    
    if (user.type === 'EX_MEMBER') {
      return 'Ex-Membru';
    }
    
    // Mapare pentru tipuri specifice în română
    const typeLabels = {
      'ADMIN': 'Administrator',
      'GUEST': 'Invitat',
      'HOST': 'Gazdă',
      'LEADER': 'Lider',
      'MANAGER': 'Manager',
      'VOLUNTEER': 'Voluntar'
    };
    
    // Returnează label-ul din mapare sau capitalizează tipul
    return typeLabels[user.type] || user.type.charAt(0).toUpperCase() + user.type.slice(1).toLowerCase();
  };

  const handleCardClick = () => {
    navigate.push(`/users/${user.id}`);
  };

  const handleContactClick = (e) => {
    // Prevent card click when clicking on email/phone
    e.stopPropagation();
  };

  return (
    <Card 
      className={styles.memberCard}
      onClick={handleCardClick}
      style={{ cursor: 'pointer' }}
    >
      {/* Avatar with Status */}
      <div className={styles.avatarSection}>
        <div className={styles.avatarWrapper}>
          <img
            src={userPhoto || DefaultUserPicture}
            alt={`${user.firstName} ${user.lastName}`}
            className={styles.avatar}
          />
          <span className={styles.onlineStatus}></span>
        </div>
      </div>

      {/* Name */}
      <h3 className={styles.memberName}>
        {user.firstName} {user.lastName}
      </h3>

      {/* Status */}
      <p className={styles.memberStatus}>{getMemberStatus()}</p>

      {/* Company with Category - Always rendered to maintain consistent spacing */}
      <div className={styles.companyInfo}>
        {user.favoriteCompany?.name && (
          <>
            <div className={styles.companyRow}>
              <BusinessIcon className={styles.companyIcon} />
              <span className={styles.companyName}>{user.favoriteCompany.name}</span>
            </div>
            {user.favoriteCompany.category && (
              <p className={styles.companyCategory}>{user.favoriteCompany.category}</p>
            )}
          </>
        )}
      </div>

      {/* Location - Always in same position */}
      {user.county?.name && (
        <div className={styles.locationRow}>
          <LocationOnIcon className={styles.locationIcon} />
          <span className={styles.locationText}>{user.county.name}, România</span>
        </div>
      )}

      {/* Footer */}
      <div className={styles.footer}>
        <div className={styles.contactIcons}>
          {user.email && (
            <a 
              href={`mailto:${user.email}`} 
              className={styles.iconButton}
              onClick={handleContactClick}
            >
              <EmailOutlinedIcon />
            </a>
          )}
          {user.phone && (
            <a 
              href={`tel:${user.phone}`} 
              className={styles.iconButton}
              onClick={handleContactClick}
            >
              <PhoneOutlinedIcon />
            </a>
          )}
        </div>

        <div 
          className={styles.profileLink}
          onClick={handleCardClick}
        >
          Profil <ArrowForwardIcon />
        </div>
      </div>
    </Card>
  );
};

export default UserCard;
